import HarIdxFrame from "../../components/HarIdxFrame";

export default function SchoolsPage() {
  return (
    <HarIdxFrame
      eyebrow="HAR · Schools"
      title="Explore Houston schools"
      description="Search schools and districts across the greater Houston area. See ratings, boundaries, and nearby homes."
      path="school/search"
      seoPath="/schools"
    />
  );
}
